export default "__VITE_ASSET__BmmJXY7b__"